import { isEmpty } from 'lodash';
import React from 'react';
import { getParagraphOne } from '../../../common/helpers/ui/dataFilter';

interface SEO {
  metadesc?: string;
}

interface Author {
  name: string;
}

interface VideoAttributes {
  views: number;
  likes: number;
  thumbnailUrl: string;
  uploadDate: string;
}
interface Post {
  title: string;
  seo?: SEO;
  author?: Author;
  videoAttributes?: VideoAttributes;
  content?: string;
}
interface VideoSchemaProps {
  post: Post;
}

const VideoSchema: React.FC<VideoSchemaProps> = ({ post }) => {
  const { title, seo, author, videoAttributes, content = '' } = post;
  const description = !isEmpty(seo.metadesc)
    ? seo.metadesc
    : getParagraphOne(content);
  const { name } = author;
  const { views, likes, thumbnailUrl, uploadDate } = videoAttributes;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: title,
    description: description,
    thumbnailUrl: thumbnailUrl,
    uploadDate: uploadDate,
    author: {
      '@type': 'Person',
      name: name,
    },
    interactionStatistic: [
      {
        '@type': 'InteractionCounter',
        interactionType: 'http://schema.org/LikeAction',
        userInteractionCount: likes,
        interactionService: {
          '@type': 'WebSite',
          name: 'YouTube',
        },
      },
      {
        '@type': 'InteractionCounter',
        interactionType: 'http://schema.org/WatchAction',
        userInteractionCount: views,
        interactionService: {
          '@type': 'WebSite',
          name: 'YouTube',
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default VideoSchema;
